import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ProductsCheckpointModelService} from '../../../Models/Tasks/Appccs/products-checkpoint-model.service';
import {ProductAppccStoreForm} from '../../../../Models/Tasks/Appccs/Checkpoints/product-appcc-store.model';

@Injectable({
  providedIn: 'root'
})
export class ProductsCheckpointApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ProductsCheckpointModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los puntos de control de los productos
   *
   */
  getProductsCheckpoints(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getAppccProductos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar un producto
   *
   */
  saveProduct(form: ProductAppccStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAppccProducto', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar producto
   *
   */
  deleteProduct(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteAppccProducto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Activar/Desactivar un producto
   *
   */
  toggleProduct(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('appccProductoToggleActivo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
